export default {
    apiKey: 'AIzaSyCf2f1EXF4rJWazpAaYyEMw4P_Y9WQJhpw',
    authDomain: 'mr-london.firebaseapp.com',
    projectId: 'mr-london',
    storageBucket: 'mr-london.appspot.com',
    messagingSenderId: '730658330518',
    appId: '1:730658330518:web:d0e2ff0f344d6593326fb7',
    measurementId: 'G-MRFW1DDWR2',
};
